import { redirect } from 'redux-first-router';
import queryString from 'query-string';
import restoreScroll from 'redux-first-router-restore-scroll';

import { isAllowed, isServer } from './utils';
import { setLanguageFromURI } from './actions/i18n';
import * as types from './actions/actionTypes';

// Checks if the incoming lang prefix from UI differs from current rehydrated
// state. If so dispatches an action to set the state language according the
// uri prefix.
const onBeforeChangeThunk = (dispatch, getState, next) => {
    const action = next.action;
    const languageFromURI = action.payload.language || null;
    const languageFromState = getState().stolo.i18n.currentLanguage.code;
    if (languageFromURI && languageFromState !== languageFromURI) {
        dispatch(setLanguageFromURI(languageFromURI));
    }
    return Promise.resolve();
};

export default {
    onBeforeChange: onBeforeChangeThunk,
    querySerializer: queryString,
    restoreScroll: restoreScroll({
        shouldUpdateScroll: (prev, locationState) => {
            if (locationState.type ===
                types.NAVIGATED_TO_SINGLE_PATTERN_VIEW &&
                prev.type ===
                types.NAVIGATED_TO_SINGLE_PATTERN_VIEW) {
                return false;
            }
            if (locationState.type === types.NAVIGATED_TO_SINGLE_PATTERN_VIEW) {
                return [0, 0];
            }
            return true;
        },
    }),
};

const alertMessage =
    "NICE, You're adventurous! Try changing the jwToken cookie from 'fake' to 'real' in server/index.js (and manually refresh) to access the Admin Panel. Then 'onBeforeChange' will let you in.";



// WEBPACK FOOTER //
// ./src/options.js